import { Model } from "@ofqual/portal-core/core/types";

export type EmbedConfig = {
  embedToken: {
    token: string;
    tokenId: string;
    expiration?: Date | null;
  };
  embedUrl: string;
  reportId: string;
};

export const fromApiModel: (model: Model) => EmbedConfig = (model) => {
  return {
    embedToken: {
      token: model.EmbedToken.token,
      tokenId: model.EmbedToken.tokenId,
      expiration: model.EmbedToken.expiration
    },
    embedUrl: model.EmbedUrl,
    reportId: model.ReportId,
  };
};

export const toApiModel: (cfg: EmbedConfig) => Model = (cfg) => {
  return {
    ...cfg
  } as Model;
};
